import React from 'react'
import {getProperSuccessClass} from 'services/getProperSuccessClass'
import Success from 'components/newsletters/shared/messages/Success'

const New = (props) => {
  return (
    <div style={{overflow: 'hidden'}} className={getProperSuccessClass(props.containerName)}>
      <Success />
    </div>
  );
}

export default New
